'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_0b64ef5e = {"container":"Sheet_module_container__7adad407","fullscreen":"Sheet_module_fullscreen__7adad407","overlay":"Sheet_module_overlay__7adad407","backdrop":"Sheet_module_backdrop__7adad407","header":"Sheet_module_header__7adad407","content":"Sheet_module_content__7adad407","footer":"Sheet_module_footer__7adad407","title":"Sheet_module_title__7adad407","title-wrapper":"Sheet_module_titleWrapper__7adad407","subtitle":"Sheet_module_subtitle__7adad407","close":"Sheet_module_close__7adad407","divider":"Sheet_module_divider__7adad407","auxiliary-layer":"Sheet_module_auxiliaryLayer__7adad407"};
require("../../../assets/cjs/components/Sheet/src/Content~Chm5kjmR.css");

exports.default = modules_0b64ef5e;
//# sourceMappingURL=Sheet.module.less.js.map
